import { Component, Suspense, useLayoutEffect, useRef } from 'react'
import Spinner from '#Components/Spinner'
import AllErrors from './ErrorScreens/AllErrors.js'
import './boundaryStyles.css'

const { DefaultError, BlogError1, BlogError2 } = AllErrors;
//NOTE, in dev mode, still renders the React error screen over the top of what gets rendered by the Error boundary

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: false };
        this.removeError = () => {
            this.setState({ error: false })
            props.status(3) //status when called with phase === 3 sets error ref from useFetch hook back to null
        }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        console.log('Error Boundary did catch!', error)
    }

    render() {
        // console.log('EB render')
        const { error } = this.state;
        const { children, status } = this.props;
        if (error) {
            // split prepended tag from error.message to determine which error screen to render
            let [tag, text] = error.message.split('++')
            switch (tag) {
            case 'blog1':
                return <BlogError1 {...{ mainText: text, titleText: "Something went wrong searching for articles", removeError: this.removeError,  }}></BlogError1>
            case 'blog2':
                return <BlogError2 {...{ mainText: text, titleText:"Unable to view requested article" , removeError: this.removeError}}></BlogError2>
            default:
                return <DefaultError {...{ text, removeError: this.removeError }}></DefaultError>
            }
        }
        return children;
    }
}

export default function Boundary({ children, status, fb }) {
    // console.log('Boundary render')
    return (
        <Suspense fallback={fb || <Spinner options={{ lineWidth: 3, petals: 9, tailLength: 'short', radius: 50, persist: true, counterSpin: true, }}></Spinner>}>
            <ErrorBoundary {...{ status }}>
                <Tester {...{ status }}>
                    {children}
                </Tester>
            </ErrorBoundary>
        </Suspense>
    )
}

function Tester({ status, children }) {
    //Extra component because promise throwing has to occur while in the rendering phase for Suspense to work properly,
    status && status(1)

    useLayoutEffect(() => {
        //easier to handle error thrown at this stage than it was during rendering
        status && status(2)
    }, [])
    return (
        <>
            {children}
        </>
    )
}